module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.c682a03f.svg";